import { useEffect, useState } from 'react';
import { logger } from '../utils/logger';
import { Music } from 'lucide-react';
import axios from 'axios';
import { TrackCard } from '../components/TrackCard';
import { AlbumCard } from '../components/AlbumCard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function MusicPage() {
  const [albums, setAlbums] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [albumsRes, tracksRes] = await Promise.all([
          axios.get(`${API_URL}/albums`),
          axios.get(`${API_URL}/tracks`)
        ]);
        setAlbums(albumsRes.data);
        setTracks(tracksRes.data);
      } catch (error) {
        logger.error('Failed to fetch data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-20">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="main-content pt-24" data-testid="music-page">
      <div className="container py-12">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center">
              <Music className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Music</h1>
              <p className="text-gray-400">Stream and purchase tracks</p>
            </div>
          </div>
        </div>

        <Tabs defaultValue="tracks" className="w-full">
          <TabsList className="mb-8 bg-white/5 p-1 rounded-lg">
            <TabsTrigger 
              value="tracks" 
              className="data-[state=active]:bg-purple-500/20 data-[state=active]:text-white px-6 py-2 rounded-md"
              data-testid="tracks-tab"
            >
              All Tracks ({tracks.length})
            </TabsTrigger>
            <TabsTrigger 
              value="albums"
              className="data-[state=active]:bg-purple-500/20 data-[state=active]:text-white px-6 py-2 rounded-md"
              data-testid="albums-tab"
            >
              Albums ({albums.length})
            </TabsTrigger>
          </TabsList>

          <TabsContent value="tracks" className="animate-fade-in">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
              {tracks.map((track) => (
                <TrackCard key={track.id} track={track} tracks={tracks} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="albums" className="animate-fade-in">
            <div className="album-grid">
              {albums.map((album) => (
                <AlbumCard key={album.id} album={album} />
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
